/* eslint-disable react/no-array-index-key */
import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Chip } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import styles from '../ProductDetails/styles.css';

const ProductAttributes = ({ attributes, productId }) => (
	<ErrorBoundary>
		<div className={styles['product-expandable-spacer']}>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="subtitle2">Attributes</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{attributes.map((attribute, index) => (
						<div className={styles['attribute-chip']} key={`${productId}${index}`}>
							<Chip
								label={`${attribute.name}: ${attribute.value}`}
								labelStyle={{ fontSize: '12.5px', lineHeight: '30px' }}
							/>
						</div>
					))}
				</AccordionDetails>
			</Accordion>
		</div>
	</ErrorBoundary>
);

ProductAttributes.propTypes = {
	attributes: PropTypes.instanceOf(Array).isRequired,

	productId: PropTypes.number.isRequired,
};

export default withStyles(styles)(ProductAttributes);
